//@ts-check

/**
 * @template T
 */
export default class DictionaryCustom {
    /**
     * @type {Object.<string, T>}
     * @private
     */
    _dictionary = {};
    /**
     * @private
     * @readonly
     */
    _funcGetDefault;

    /** @param {(key: string) => T} funcGetDefault  */
    constructor(funcGetDefault) {
        this._funcGetDefault = funcGetDefault;
    }

    /**
     * @param {string} key
     * @returns {T}
     */
    Get(key) {
        if (!(key in this._dictionary)) {
            this._dictionary[key] = this._funcGetDefault(key);
        }

        return this._dictionary[key];
    }

    Clear() {
        this._dictionary = {}
    }

    get keys() {
        return Object.keys(this._dictionary);
    }

    get values() {
        return Object.values(this._dictionary);
    }
}